import {
  primaryDark,
  bannerFontFamily,
  primaryFontFamily,
  breakpointSm,
  breakpointLg,
} from '../style/variables';

const headingStyles = {
  fontFamily: bannerFontFamily,
  fontWeight: 'bold',
  lineHeight: 0.8,
  letterSpacing: 0,
  textTransform: 'uppercase',
};

const body1Styles = {
  fontFamily: primaryFontFamily,
  fontSize: '1rem',
  lineHeight: '1.5rem',
  [`@media (min-width: ${breakpointSm})`]: {
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
  },
  '&.flexible': {
    fontSize: 'clamp(1rem, 0.8866rem + 0.4651vw, 1.375rem)',
  },
};

const typography = {
  h1: {
    ...headingStyles,
    fontSize: '4rem',
    lineHeight: '3.25rem',
    [`@media (min-width: ${breakpointSm})`]: {
      fontSize: '7rem',
      lineHeight: '5.5rem',
    },
    '&.flexible': {
      fontSize: 'clamp(5rem, 3.4884rem + 6.2016vw, 10rem)',
      lineHeight: '0.8em',
    },
  },
  h2: {
    ...headingStyles,
    fontSize: '3.5rem',
    lineHeight: '3rem',
    [`@media (min-width: ${breakpointSm})`]: {
      fontSize: '4.5rem',
      lineHeight: '4rem',
    },
    '&.flexible': {
      fontSize: '13.5vw',
      lineHeight: '0.8em',
    },
    // tablet
    [`@media screen and (min-width: ${breakpointSm}) and (max-width: ${breakpointLg}) and (orientation: portrait)`]:
      {
        '&.flexible': {
          fontSize: '11.5vw',
        },
      },
    // desktop
    [`@media screen and (min-width: ${breakpointSm}) and (orientation: landscape)`]: {
      '&.flexible': {
        fontSize: '5.5vw',
      },
    },
  },
  h3: {
    ...headingStyles,
    fontSize: '3rem',
    lineHeight: '2.5rem',
    [`@media (min-width: ${breakpointSm})`]: {
      fontSize: '4rem',
      lineHeight: '3.5rem',
    },
    '&.flexible': {
      fontSize: '12vw',
      lineHeight: '0.8em',
    },
    // // tablet
    // [`@media screen and (min-width: ${breakpointSm}) and (max-width: ${breakpointLg}) and (orientation: portrait)`]: {
    //   '&.flexible': {
    //     fontSize: '10vw',
    //   },
    // },
    // // desktop
    // [`@media screen and (min-width: ${breakpointSm}) and (orientation: landscape)`]: {
    //   '&.flexible': {
    //     fontSize: '5vw',
    //   },
    // },
  },
  h4: {
    ...headingStyles,
    fontSize: '2rem',
    lineHeight: '1.625rem',
    [`@media (min-width: ${breakpointSm})`]: {
      fontSize: '3rem',
      lineHeight: '2.5rem',
    },
  },
  h5: {
    ...headingStyles,
    fontSize: '1.5rem',
    lineHeight: '1.25rem',
    [`@media (min-width: ${breakpointSm})`]: {
      fontSize: '2.5rem',
      lineHeight: '2rem',
    },
  },
  h6: {
    ...headingStyles,
    fontSize: '1.25rem',
    lineHeight: '1.125rem',
    [`@media (min-width: ${breakpointSm})`]: {
      fontSize: '2rem',
      lineHeight: '1.625rem',
    },
  },
  subtitle1: {
    ...headingStyles,
    fontWeight: 'normal',
    letterSpacing: '1.5px',
    fontSize: '1.5rem',
    lineHeight: '1.25rem',
    [`@media (min-width: ${breakpointSm})`]: {
      fontSize: '2rem',
      lineHeight: '2rem',
      letterSpacing: '2px',
    },
  },
  body1: {
    ...body1Styles,
    // Apply the following styles to markdown within typography
    '& > p': {
      ...body1Styles,
      marginBottom: 0,
      '& a': {
        color: primaryDark,
      },
    },
    '&.flexible > p': {
      fontSize: 'clamp(1rem, 0.8866rem + 0.4651vw, 1.375rem)',
      [`@media (min-width: ${breakpointSm})`]: {
        lineHeight: '1.82',
      },
    },
    '& > ul > li': {
      paddingLeft: '0.75rem',
      paddingBottom: '0.5rem',
    },
  },
  body2: {
    fontFamily: primaryFontFamily,
    fontSize: '0.875rem',
    lineHeight: '1.375rem',
    [`@media (min-width: ${breakpointSm})`]: {
      fontSize: '1rem',
      lineHeight: '1.5rem',
    },
  },
};

export default typography;
